export default "__VITE_ASSET__476ee792__$_?nuxt_component=async&nuxt_component_name=SvgoGgBg5__"